/**
 * agruparPorSalida — helper compartido entre HoyPage y ProximasPage.
 *
 * Agrupa un array de reservas por `salida_id` (paquete + hora + embarcaciones).
 * Ordena grupos por hora de zarpe ASC y las reservas dentro de cada grupo por
 * nombre del cliente ASC. Las reservas sin `salida_id` (típicamente alquileres
 * o walk-in muelle) caen a `sinSalida` para renderizarse aparte.
 *
 * Salida:
 *   {
 *     grupos: [ { salida_id, hora, paquete, lanchas, capacidad,
 *                 ocupados, reservas: [...] }, ... ],
 *     sinSalida: [...]
 *   }
 */
export function agruparPorSalida(rows) {
  const grupos = new Map();
  const sinSalida = [];
  (rows || []).forEach(r => {
    const sid = r.salida_id;
    if (!sid) { sinSalida.push(r); return; }
    if (!grupos.has(sid)) {
      grupos.set(sid, {
        salida_id: sid,
        hora: r.salida_hora,
        paquete: r.paquete_nombre || r.alquiler_nombre,
        lanchas: r.salida_embarcaciones || [],
        capacidad: Number(r.salida_capacidad || 0),
        ocupados: Number(r.salida_asientos_reservados || 0),
        reservas: [],
      });
    }
    grupos.get(sid).reservas.push(r);
  });
  const arr = Array.from(grupos.values());
  arr.sort((a, b) => (a.hora || '').localeCompare(b.hora || ''));
  arr.forEach(g => g.reservas.sort(
    (a, b) => (a.nombre_cliente || '').localeCompare(b.nombre_cliente || '')
  ));
  return { grupos: arr, sinSalida };
}

export default agruparPorSalida;
